import axios from "axios";
import config from "../component/config";
const envVar = process.env;

export const pgw = axios.create({
  baseURL: config.pgw,
  auth: {
    username: envVar.REACT_APP_BASIC_AUTH_USERNAME,
    password: envVar.REACT_APP_BASIC_AUTH_PASSWORD,
  },
  headers: {
    Accept: "*/*",
    "Access-Control-Allow-Origin": "*",
    "Content-type": "application/json",
    "treas-api-key": envVar.REACT_APP_KEY,
  },
});
